<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form :inline="true" :model="searchForm" label-suffix=":" :size="size" @submit.native.prevent>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('대행사 구분')">
              <el-select v-model="searchForm.agencyTypes" @change="search">
                <el-option
                  v-for="agencyType in agencyTypes"
                  :key="agencyType.value"
                  :label="agencyType.label"
                  :value="agencyType.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('DeliverySearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <span class="buttons">
        <el-button
          v-if="checkAuthActionAccess('DeliveryAdd')"
          :size="size"
          @click="add"
          icon="el-icon-circle-plus-outline"
          :disabled="btn.addDisabled"
          >{{ $t('등록') }}</el-button
        >
        <el-button
          v-if="checkAuthActionAccess('DeliveryUp')"
          :size="size"
          @click="up"
          icon="el-icon-edit-outline"
          :disabled="btn.upDisabled"
          >{{ $t('수정') }}</el-button
        >
        <el-button
          v-if="checkAuthActionAccess('DeliveryDel')"
          :size="size"
          @click="del"
          icon="el-icon-remove-outline"
          :disabled="btn.delDisabled"
          >{{ $t('삭제') }}</el-button
        >
        <el-button
          v-if="checkAuthActionAccess('DeliveryAdd') || checkAuthActionAccess('DeliveryUp')"
          :size="size"
          @click="save"
          icon="el-icon-check"
          :disabled="btn.saveDisabled"
          style="float: right"
          >{{ $t('저장') }}</el-button
        >
      </span>
    </div>

    <!-- 리스트 -->
    <template v-if="true">
      <el-row :gutter="20">
        <el-col :span="16">
          <el-table
            :height="tableHeight"
            ref="table"
            border
            stripe
            highlight-current-row
            tooltip-effect="dark"
            :data="tableData"
            :size="size"
            :empty-text="$t('데이타 없음')"
            @row-click="handleRowClick"
            @select="handleRowChecked"
            @select-all="handleRowChecked">
            <el-table-column
              :label="tableData.length.toString()"
              type="index"
              width="55"
              align="center"
              sortable
              label-class-name="data_cnt"></el-table-column>
            <el-table-column type="selection" width="45" align="center"></el-table-column>
            <el-table-column
              :label="$t('대행사 구분')"
              prop="agencyName"
              min-width="80"
              align="center"
              sortable></el-table-column>
            <el-table-column
              :label="$t('브랜드 코드')"
              prop="brandCode"
              min-width="120"
              align="center"
              sortable
              show-overflow-tooltip></el-table-column>
            <el-table-column
              :label="$t('브랜드명')"
              prop="brandName"
              min-width="200"
              sortable
              show-overflow-tooltip></el-table-column>
            <!--						<el-table-column :label="$t('API 매핑 가능 여부')" prop="api_mapping_yn" min-width="80" align="center" sortable show-overflow-tooltip></el-table-column>-->
          </el-table>
        </el-col>
        <el-col :span="8">
          <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
            <div slot="header">
              <span>{{ $t('대행 업체/브랜드') }}</span>
              <span if="'I' == inputForm.statu">{{ $t('추가') }}</span>
              <span v-if="'U' == inputForm.statu">{{ $t('수정') }}</span>
            </div>
            <div>
              <el-form
                :model="inputForm"
                :label-width="$device.mobile ? `` : `120px`"
                label-suffix=":"
                :size="size"
                :disabled="fromDisabled"
                @submit.native.prevent>
                <el-form-item :label="$t('대행사 구분')" :error="formError.agencyType" required>
                  <combo
                    :data="inputFormAgencyTypes"
                    :model="inputForm.agencyType"
                    @change="inputForm.agencyType = $event"></combo>
                </el-form-item>
                <el-form-item :label="$t('브랜드 코드')" :error="formError.brandCode" required>
                  <el-input v-model="inputForm.brandCode" maxlength="50" clearable show-word-limit></el-input>
                </el-form-item>
                <el-form-item :label="$t('브랜드명')" :error="formError.brandName" required>
                  <el-input v-model="inputForm.brandName" maxlength="50" clearable show-word-limit></el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
import mainVueMixin from '@/mixins/mainVueMixin'
import { initData } from '@/utils/constants'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.agencyTypes = [
      { label: this.$t('헬로월드'), value: 'HELLO_WORLD' },
      { label: this.$t('바로고'), value: 'BAROGO' },
    ]
    data.inputFormAgencyTypes = [
      { label: this.$t('헬로월드'), value: 'HELLO_WORLD' },
      { label: this.$t('바로고'), value: 'BAROGO' },
    ]

    return data
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        agencyTypes: 'HELLO_WORLD',
      }
    },
    // 입력 폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        id: 0,
        agencyType: 'HELLO_WORLD',
        companyCode: '',
        companyName: '',
        brandCode: '',
        brandName: '',
        api_mapping_yn: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        agencyType: '',
        companyCode: '',
        companyName: '',
        brandCode: '',
        brandName: '',
        api_mapping_yn: '',
      }
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].id
      }
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        '/delivery/search',
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true
          this.btn.saveDisabled = true
          this.fromDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.inputForm.title = this.$t('대행 업체 추가')
      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        '/delivery/' + this.selectData.id,
        function (result) {
          result.statu = 'U'
          result.title = this.$t('대행 업체 수정')

          this.inputForm = result

          this.formError = this.initFormError()

          this.btn.saveDisabled = false
          this.fromDisabled = false
        }.bind(this)
      )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          '/delivery',
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.fromDisabled = false
            alert('ss')
            this.search()
          }.bind(this)
        )
      } else {
        this.mainVue.$axios.up(
          '/delivery/' + this.selectData.id,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.fromDisabled = false
            alert('ss')
            this.search()
          }.bind(this)
        )
      }
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('메뉴 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              '/delivery/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
  },
}
</script>
